import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';

import { ManageAccessRoutingModule } from './manage-access-routing.module';
import { ManageAccessComponent } from './manage-access.component';
import { ShareAccessComponent } from './share-access/share-access.component';

@NgModule({
    imports: [
        ReactiveFormsModule,
        CommonModule,
        ManageAccessRoutingModule,
        SharedModule,
        ManageAccessComponent,
        ShareAccessComponent
    ]
})
export class ManageAccessModule {
}
